<h2>Help</h2>
  <!-- <label for="validationTextarea">Textarea</label> -->
  <!-- <textarea class="form-control mt-4" id="validationTextarea" placeholder="How can we help you today?" required></textarea>
  <div class="form-group mt-3">
    <dhhp-button type="raised" color="primary" value="Start live chat" class="card-header-action"></dhhp-button>
  </div> -->
